import { render, staticRenderFns } from "./FieldReassignmentAuditTrail.vue?vue&type=template&id=9276ecb6&"
import script from "./FieldReassignmentAuditTrail.vue?vue&type=script&lang=ts&"
export * from "./FieldReassignmentAuditTrail.vue?vue&type=script&lang=ts&"
import style0 from "./FieldReassignmentAuditTrail.vue?vue&type=style&index=0&id=9276ecb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports